import * as React from "react";
import {Component } from "react";

import "./contractor-item.scss";

import {observer} from "mobx-react";

import {Item, Label} from "semantic-ui-react";

import {Contractor} from "../../models/contractor";


export interface ContractorItemProps {
    contractor: Contractor | null;
    handleShowContractor: (contractor: Contractor, e: React.MouseEvent) => void;
}

@observer
export class ContractorItem extends Component<ContractorItemProps, any> {
    watchHandles: any[] = [];
    constructor(props: ContractorItemProps) {
        super(props);
        this.state = {};
    }

    componentDidMount(): void {}

    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }

    render(): React.ReactElement | null {
        const {contractor, handleShowContractor} = this.props;

        if (!contractor) {
            return null;
        }

        return (
            <Item className="contractor-item"
                onClick={(event: React.MouseEvent) => handleShowContractor(contractor, event)}>
                <Item.Content>
                    <Item.Header as={"h4"}>
                        <span className="contractor-id">{contractor.id}</span>{contractor.organisation}
                    </Item.Header>
                    <Item.Description>
                        {`${contractor.postalCode} ${contractor.city}`}
                    </Item.Description>
                    <Item.Extra>
                        <Label icon="user circle" content={contractor.contact} />
                        <Label icon="mail outline" content={contractor.email} />
                    </Item.Extra>
                </Item.Content>
            </Item>
        );
    }
}
